//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    blok: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    getLink(link) {
      if (link.cached_url == 'home') {
        return ''
      } else {
        return link.cached_url
      }
    }
  }
}
